"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionAttachmentFileEditor = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const TransactionAttachmentFileEditor = ({ modalType, }) => {
    if (modalType === "remove") {
        return (0, jsx_runtime_1.jsx)("div", { children: "Remove transaction file?" });
    }
    return (0, jsx_runtime_1.jsx)("div", {});
};
exports.TransactionAttachmentFileEditor = TransactionAttachmentFileEditor;
